module.exports = __webpack_public_path__ + "img/scratch_image_sample.a8254161.png";